<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-row style="background-color: #F3F4F4;">
      <el-col :xs="6" :md="6"
        style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;display:flex;align-items:center;">
        <img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
        合同列表
        <el-select style="width: 60%;margin-left:20px;" v-model="dataForm.contractType" placeholder="合同类别"
          @change="getvalue" clearable v-if="isQyyh != 'COMPANY'">
          <el-option v-for="item in jiesuan" :key="item.value" :label="item.label" :value="item.value"
            :disabled="item.disabled"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="18" :md="18">

        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(); getNumCount();"
          style="text-align: right;">
          <el-form-item>
            <el-button v-if="$hasPermission('plat:platcontract:save')" type="primary" @click="childHandle('')">{{
              $t('add') }}</el-button>
            <!-- <el-button v-if="$hasPermission('plat:platcontract:save') && (dataForm.bodyId == '1453241566079012865' || $store.state.user.bodyIds == '1453241566079012865')" type="primary" @click="childHandle('')">{{ $t('add') }}</el-button> -->
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('plat:platcontract:export')" type="info" @click="exportHandle()">{{
              $t('export') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="refreshBtn" type="default" @click="getDataList(); getNumCount();">刷新</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="delBtn" style="left: 760px;" v-if="$hasPermission('plat:platcontract:delete')"
              type="danger" @click="deleteHandle()">
              {{ $t('deleteBatch') }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="background-color: #f3f4f4" v-if="this.dataForm.contractType != 'grht'">
      <el-col style="
          line-height: 40px;
          font-size: 16px;
          color: #121212;
          font-weight: bold;
          background: #fff;
        ">
        <button v-for="(item, index) in headMetaBtn" class="auxiliary-accounting-btn"
          :class="{ active: index == headMetaIndex }" @click="handleHeadMetaBtn(index)">
          {{ `${item.name ? item.name : 0}` }}({{ item.num }})
          <!-- {{`${item.name}`}} -->
        </button>
      </el-col>
    </el-row>
    <div class="mod-plat__platcontract">
      <el-form label-width="80px" style="padding:0 5px 0px;" ref="loginFormRef" :model="dataForm"
        @keyup.enter.native="getDataList(); getNumCount();">
        <el-row>
          <el-col :md="12" :lg="5" v-if="dataForm.contractType != 'grht'">
            <el-form-item label="甲方主体:" prop="firstBody">
              <el-input style="width: 100%;" v-model="dataForm.firstBody" placeholder="甲方主体"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="6" v-else>
            <el-form-item label="甲方主体:" prop="bodyId">
              <el-select v-model="dataForm.bodyId" placeholder="请选择" style="width:100%" clearable filterable
                :disabled="isSourceOfTax == 1">
                <el-option v-for="item in bodyPageList" :key="item.id" :label="`${item.bodyName}-${item.abbreviation}`"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :md="12" :lg="6">
            <el-form-item label="乙方主体:" prop="secondBody">
              <el-input style="width: 100%;" v-model="dataForm.secondBody" placeholder="乙方主体"></el-input>
            </el-form-item>
			  </el-col> -->
          <el-col :md="12" :lg="8">
            <el-form-item label="录入时间:">
              <el-date-picker :picker-options='pickerStartOptions(dataForm.endDate)' style="width: 48%"
                v-model="dataForm.startDate" placeholder="开始时间" type="date" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"></el-date-picker>
              <span style="width:4%;text-align: center;display: inline-block;">~</span>
              <el-date-picker :picker-options='pickerEndOptions(dataForm.startDate)' style="width: 48%"
                v-model="dataForm.endDate" placeholder="结束时间" type="date" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"></el-date-picker>
              <!-- <el-date-picker style="width:48%" :picker-options='pickerStartOptions(dataForm.endDate)' v-model="dataForm.startDate" placeholder="开始时间" type="date" @change="formatStartTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            <span style="width:4%;text-align: center;display: inline-block;">~</span>
            <el-date-picker style="width:48%" :picker-options='pickerEndOptions(dataForm.startDate)' v-model="dataForm.endDate" placeholder="结束时间"  type="date" @change="formatEndTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker> -->
            </el-form-item>
          </el-col>
          <!-- <el-col :md="12" :lg="5">
			  		<el-form-item label="任务属性:" prop="settleType">
			  		  <ren-select style="width: 100%;" v-model="dataForm.settleType" dict-type="settleType" :isDisabled="is_reader"></ren-select>
			  		</el-form-item>
			  </el-col> -->
          <el-col :md="12" :lg="5">
            <el-form-item label="合同编号:" prop="contractCode">
              <el-input v-model="dataForm.contractCode" style="width: 100%;" placeholder="合同编号"></el-input>
            </el-form-item>
          </el-col>

          <el-col :md="12" :lg="6">
            <el-form-item label="合同状态:" prop="status" v-if="dataForm.contractType == 'grht'">
              <el-select style="width: 100%;" v-model="dataForm.status">
                <el-option label="未签署" :value="1">
                </el-option>
                <el-option label="已签署" :value="2">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同状态:" prop="status" v-else>
              <ren-select style="width: 100%;" v-model="dataForm.status" dict-type="contractStatus" ></ren-select>
            </el-form-item>
            <!-- <el-form-item label="合同状态:" prop="status" v-show="dataForm.bodyId == '1453241566079012865'"> -->
            <!-- <ren-select style="width: 100%;" v-model="dataForm.status" dict-type="contractStatus"></ren-select> -->
            <!-- <ren-select style="width: 100%;" v-model="dataForm.status" dict-type="contractStatus" :isDisabled="true"></ren-select> -->
            <!-- </el-form-item> -->
          </el-col>



          <!-- <el-col :md="12" :lg="8">
            <el-form-item label="合同金额:">
              <el-input  v-model="dataForm.money1"  placeholder="合同金额" style="width: 48%"></el-input>
              <span style="width:4%;text-align: center;display: inline-block;">~</span>
              <el-input  v-model="dataForm.money2" placeholder="合同金额" style="width: 48%"></el-input>
            </el-form-item>
			  </el-col> -->

        </el-row>
        <el-row>
          <!-- <el-col :md="12" :lg="5" v-if="dataForm.contractType == 'grht'">
            <el-form-item label="乙方主体:" prop="firstBody">
              <el-input style="width: 100%;" v-model="dataForm.firstBody" placeholder="乙方主体"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :md="12" :lg="6" v-if="dataForm.contractType != 'grht'">
            <el-form-item label="乙方主体:" prop="bodyId">
              <el-select v-model="dataForm.bodyId" placeholder="请选择" style="width:100%" filterable
                @change="handleBodyIdChange" :disabled="isSourceOfTax == 1">
                <el-option v-for="item in bodyPageList" :key="item.id" :label="`${item.bodyName}-${item.abbreviation}`"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="dataForm.contractType != 'grht' ? 18 : 24" style="text-align: right;">
            <el-form-item label-width="0px">
              <el-button type="primary" @click="getDataList(); getNumCount();">{{ $t('query') }}</el-button>
              <el-button type="info" @click="resetLoginForm">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle"
        style="width: 100%;" height="100%">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contractCode" label="合同申请编号" header-align="center" align="center"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="firstUser" v-if="dataForm.contractType != 'grht'" label="负责人" header-align="center"
          align="center"></el-table-column>
        <!-- <el-table-column prop="contractType" label="合同类别" header-align="center" align="center">
          <template slot-scope="scope">
            {{ $getDictLabel("contractType", scope.row.contractType) }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="remark" label="合同内容" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
        <el-table-column :prop="dataForm.contractType == 'grht' ? 'abbreviation' : 'firstBody'" label="甲方主体"
          header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column v-if="dataForm.contractType != 'grht'" :prop="dataForm.contractType == 'grht' ? 'secondBody' : 'abbreviation'" label="乙方主体"
          header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="money" label="合同金额(元)" header-align="center" align="center"></el-table-column> -->
         {{ dataForm.contractType }}
        <el-table-column prop="status" label="合同状态" header-align="center" align="center"
          v-if="dataForm.contractType == 'grht'">
          <template slot-scope="scope">
            <!-- <el-tag v-if="scope.row.status == 0" size="small" type="danger">草稿</el-tag> -->
            <!-- <el-tag v-if="scope.row.status == 1" size="small" type="warning">已提交</el-tag> -->
            <el-tag v-if="scope.row.status == 1" size="small" type="danger">未签署</el-tag>
            <el-tag v-else-if="scope.row.status == 2" size="small" type="success">已签署</el-tag>
            <el-tag v-else size="small" type="success"></el-tag>
            <!-- <el-tag v-if="scope.row.status == 3" size="small" type="info">已关闭
            </el-tag> -->
          </template>
        </el-table-column>
        <el-table-column prop="status" label="合同状态" header-align="center" align="center" v-else>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0" size="small" type="danger">草稿</el-tag>
            <el-tag v-else-if="scope.row.status == 1" size="small" type="warning">已提交</el-tag>
            <el-tag v-else size="small" type="success">已审核</el-tag>
            <!-- <el-tag v-if="scope.row.status == 3" size="small" type="info">已关闭
            </el-tag> -->
          </template>
        </el-table-column>
        <el-table-column prop="isEnable" label="是否启用" header-align="center" align="center" show-overflow-tooltip
          v-if="dataForm.contractType != 'grht'">
          <template slot-scope="scope">
            <span>{{ scope.row.isEnable == 0 ? '已禁用' : '已启用' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sourceOrg" label="来源企业" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.sourceOrg == 'HY' ? '海茵科技' : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="录入时间" header-align="center" align="center"
          show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <span v-if="dataForm.contractType != 'grht' && isSourceOfTax != 1"
              @click="fnSetIsEnable(scope.row)"><el-button class="item" type="text" size="small">{{ scope.row.isEnable ==
                0 ? '启用' : '禁用'}}</el-button></span>
            <el-tooltip class="item" effect="dark" content="只有草稿状态才可修改。如已提交发布，请先进行驳回操作！" placement="left">
              <span><el-button v-if="$hasPermission('plat:platcontract:update') && scope.row.contractType != 'grht'" type="text" size="small"
                  :disabled="scope.row.status != '0'" @click="childHandle(scope.row.id)">{{ $t('update')
                  }}</el-button></span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="只有草稿状态才可删除。如已提交发布，请先进行驳回操作！" placement="left">
              <span><el-button v-if="$hasPermission('plat:platcontract:delete') && scope.row.contractType != 'grht'" type="text" size="small"
                  :disabled="scope.row.status != '0'" @click="deleteHandle(scope.row.id)">{{ $t('delete')
                  }}</el-button></span>
            </el-tooltip>
            <!-- <el-tooltip v-if="scope.row.fddPdfViewUrl && scope.row.contractType == 'grht'" class="item" effect="dark"
              :content="scope.row.status < 2 ? '在详情页面中进行审核！' : '合同已审核，点击查看'" placement="left">
              <el-button type="text" size="small"
                @click="infoHandle(scope.row.id, scope.row.contractType, scope.row.fddPdfViewUrl, scope.row)">详情</el-button>
            </el-tooltip>
            <el-tooltip v-if="!scope.row.fddPdfViewUrl && scope.row.contractType == 'grht'" class="item" effect="dark"
              content="个人合同异常，请重新签约" placement="left">
              <el-button type="text" size="small"
                @click="infoHandle(scope.row.id, scope.row.contractType, scope.row.fddPdfViewUrl, scope.row)"
                :disabled="true">详情</el-button>
            </el-tooltip> -->
            <el-tooltip v-if="scope.row.contractType == 'qyht'" class="item" effect="dark"
              :content="scope.row.status < 2 ? '在详情页面中进行审核！' : '合同已审核，点击查看'" placement="left">
              <el-button type="text" size="small"
                @click="infoHandle(scope.row.id, scope.row.contractType, scope.row.fddPdfViewUrl, scope.row)">详情</el-button>
            </el-tooltip>
            <el-button type="text" size="small"  @click="infoHandle(scope.row.id, scope.row.contractType, scope.row.fddPdfViewUrl, scope.row)" v-if="scope.row.status == 2 && scope.row.contractType == 'grht'">查看</el-button>
            <!-- <el-button type="text" size="small" @click="grhtDownFilt(scope.row)" v-if="scope.row.status == 2 && scope.row.contractType == 'grht' && (scope.row.bodyId == '2049068836784115713' || scope.row.bodyId == '2046510676422860802')">下载</el-button> -->

            <!-- <el-button v-if="scope.row.contractType == 'qyht'" type="text" size="small" @click="infoHandle(scope.row.id, scope.row.contractType, scope.row.fddPdfViewUrl, scope.row)">详情</el-button> -->


            <!-- <el-tooltip v-if="scope.row.fddPdfDownloadUrl" class="item" effect="dark" content="点击下载文件！"
              placement="left">
              <el-link target="_blank" style="color: #3877F3;"
                class="el-button el-tooltip item el-button--text el-button--small" v-if="scope.row.contractType == 'grht'"
                :href="scope.row.fddPdfDownloadUrl" :underline="false">
                下载
              </el-link>
            </el-tooltip> -->
            <!-- <el-tooltip v-else class="item" effect="dark" content="个人合同异常，请重新签约！" placement="left">
              <span><el-button type="text" size="small" :disabled="true">下载</el-button></span>
            </el-tooltip> -->

            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
        layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <deputy-info v-if="deputyInfoVisible" ref="deputyInfo" @refreshDataList="getDataList"></deputy-info>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './platcontract-add-or-update'
import DeputyInfo from './platcontract-info'
import DateUtils from '@/utils/DateUtils.js'
import qs from 'qs'
import Cookies from 'js-cookie'
import { addDynamicRoute } from '@/router'
import { PDFDocument, StandardFonts } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      isSourceOfTax: Cookies.get("isSourceOfTax"),
      bodyPageList: [],
      pickerStartOptions(endTime) {
        return {
          disabledDate(time) {
            if (endTime) {
              // 拼接 00:00:00 是为了统一日期从0点开始 
              return time.getTime() > new Date(endTime + ' 00:00:00').getTime();
            }
          }
        }
      },
      pickerEndOptions(startTime) {
        return {
          disabledDate(time) {
            if (startTime) {
              // 拼接 00:00:00 是为了统一日期从0点开始 
              return time.getTime() < new Date(startTime + ' 00:00:00').getTime();
            }
          }
        }
      },
      headMetaBtn: [
        { name: "正常", id: 0, num: 0 },
        { name: "即将到期", id: 2, num: 0 },
        { name: "已到期", id: 1, num: 0 },
      ],
      headMetaIndex: 0,
      isQyyh: Cookies.get('admin_role'),
      deputyInfoVisible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/contract/page',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/contract',
        deleteIsBatch: true,
        exportURL: '/sys/plat/contract/export'
      },
      jiesuan: [
        {
          value: 'grht',
          label: '个人合同'
        },
        {
          value: 'qyht',
          label: '企业合同'
        }
      ],
      is_reader: false,
      dataForm: {
        // bodyId:Cookies.get('admin_role') == 'OPERATE' || this.$store.state.user.bodyIds == '1453241566079012865' ? '1453241566079012865' : '',
        bodyId: '',
        contractCode: '',
        money1: '',
        money2: '',
        contractType: 'qyht',
        firstBody: '',
        status: '',
        settleType: '',
        secondBody: '',
        startDate: '',
        endDate: '',
        expire: 0
      }
    }
  },
  watch: {
    'dataForm.money1': {
      handler: function (val, oldval) {
        let reg = /^(([1-9][0-9]*)|(([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2})))$/;
        if ((!reg.test(val)) && val != '') {
          this.dataForm.money1 = oldval
        }
      },
      deep: true
    },
    'dataForm.money2': {
      handler: function (val, oldval) {
        let reg = /^(([1-9][0-9]*)|(([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2})))$/;
        if (!reg.test(val) && val != '') {
          this.dataForm.money2 = oldval
        }
      },
      deep: true
    },

  },
  components: {
    AddOrUpdate,
    DeputyInfo
  },
  created() {
    if (localStorage.getItem(this.$route.name)) {
      // console.log(JSON.parse(localStorage.getItem(this.$route.name)).expire)
      let localIndex = JSON.parse(localStorage.getItem(this.$route.name)).expire;
      this.headMetaIndex = localIndex == 1 ? 2 : localIndex == 2 ? 1 : localIndex;
    }
    this.getNumCount();
    // console.log(this.isSourceOfTax)
  },
  methods: {
    // 税源地切换
    handleBodyIdChange(e) {
      this.dataForm.bodyId = e;
      // console.log(this.dataForm.bodyId)
      // 湖南税源地
      // if(e != '1453241566079012865'){
      //   this.dataForm.status = 2;
      // }else{
      this.dataForm.status = ''
      // }
      this.getDataList();
    },
    // 设置合同状态是否启用
    async fnSetIsEnable(row) {
      const res = await this.$http.post('/sys/plat/contract/isEnable', {
        id: row.id,
        isEnable: row.isEnable == 0 ? 1 : 0
      })
      // console.log(res)
      if (res.data.code == 0) {
        this.getDataList();
      }
    },
    // 获取数量
    async getNumCount() {
      const res = await this.$http.get(`sys/plat/contract/count?bodyId=${this.dataForm.bodyId}`, {});
      this.headMetaBtn[0].num = res.data.data.unexpired;
      this.headMetaBtn[1].num = res.data.data.expiringSoon;
      this.headMetaBtn[2].num = res.data.data.hasExpired;
      const res1 = await this.$http.get('/sys/plat/body/page?page=1&limit=1000&isallsyd=1', {});
      if (res1.data.code !== 0) {
        return this.$message.error(res1.msg)
      } else {
        if (this.isSourceOfTax == 1) {
          this.bodyPageList = res1.data.data.list
          this.dataForm.bodyId = this.$store.state.user.bodyIds
        } else {
          this.bodyPageList = res1.data.data.list
        }
      }
    },
    // 状态切换
    handleHeadMetaBtn(ind) {
      this.dataForm.contractCode = '';
      this.dataForm.money1 = '';
      this.dataForm.money2 = '';
      this.dataForm.firstBody = '';
      this.dataForm.status = '';
      this.dataForm.settleType = '';
      this.dataForm.secondBody = '';
      this.dataForm.startDate = '';
      this.dataForm.endDate = '';
      this.dataForm.bodyId = '';
      // if(this.isQyyh == 'OPERATE' || this.$store.state.user.bodyIds == '1453241566079012865'){
      //   this.dataForm.bodyId = '1453241566079012865'
      // }else{
      // this.dataForm.status = 2;
      // }
      // this.getNum();
      this.headMetaIndex = ind;
      this.$nextTick(() => {
        this.dataForm.expire = this.headMetaBtn[this.headMetaIndex].id
        this.getDataList()
        this.getNumCount()
      })
    },
    formatStartTime(val) {
      this.dataForm.startDate = val + ' 00:00:00'
    },
    formatEndTime(val) {
      this.dataForm.endDate = val + ' 23:59:59'
    },
    downHandle(url) {

    },
    async grhtDownFilt(row) {
      // console.log(row)
      try {
        // this.$message.info('正在下载合同文件，请稍候...')
        
        const templatePdfUrl = '/template/mb.pdf'
        // const templatePdfUrl = '/template/模版.pdf'
        const existingPdfBytes = await fetch(templatePdfUrl).then(res => res.arrayBuffer())
        
        const pdfDoc = await PDFDocument.load(existingPdfBytes)
        
        pdfDoc.registerFontkit(fontkit)
        
        const fontUrl = '/template/字体圈欣意吉祥宋.ttf'
        // console.log('正在加载字体:', fontUrl)
        
        const response = await fetch(fontUrl)
        if (!response.ok) {
          throw new Error(`字体文件加载失败: ${response.status} ${response.statusText}`)
        }
        
        const fontBytes = await response.arrayBuffer()
        // console.log('字体文件大小:', fontBytes.length, 'bytes')
        // console.log('字体文件头部 (前16字节):', Array.from(new Uint8Array(fontBytes.slice(0, 16))))
        
        const customFont = await pdfDoc.embedFont(fontBytes)
        
        const form = pdfDoc.getForm()
        
        // console.log('=== PDF表单字段信息 ===')
        const fieldNames = form.getFields().map(field => field.getName())
        // console.log('模板中包含的字段:', fieldNames)
        
        const fields = {
          name: row.secondBody || '',
          idCard: row.secondTaxCode || '',
          // address: row.address || '',
          phone: row.secondPhone || '',
          firstDate: DateUtils.format(row.createDate, 'yyyy-MM-dd') || '',
          // secondSeal: row.createDate || '',
          secondDate: DateUtils.format(row.createDate, 'yyyy-MM-dd') || '',
        }
        
        // console.log('尝试填充的数据:', fields)
        
        Object.keys(fields).forEach(fieldName => {
          try {
            const field = form.getTextField(fieldName)
            if (field && fields[fieldName]) {
              field.setText(fields[fieldName])
              field.updateAppearances(customFont)
              // console.log(`✓ 成功填充字段 ${fieldName}: ${fields[fieldName]}`)
            }
          } catch (e) {
            console.warn(`✗ 字段 ${fieldName} 填充失败:`, e.message)
          }
        })
        
        form.flatten()
        
        const pdfBytes = await pdfDoc.save()
        
        const blob = new Blob([pdfBytes], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `个人合同_${row.contractCode || Date.now()}.pdf`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        
        this.$message.success('合同文件下载成功！')
      } catch (error) {
        console.error('下载失败:', error)
        this.$message.error('下载失败，请重试！')
      }
    },
    // 查看
    infoHandle(id, type, url, param) {
      // console.log(param)
      if (type == 'grht') {
        window.open(url)
      } else {
        localStorage.setItem(this.$route.name, JSON.stringify(this.dataForm))
        // 湖南税源地
        // if(param.bodyId == '1453241566079012865'){
        // 路由参数
        const routeParams = {
          routeName: `${this.$route.name}__合同详情`,
          title: `合同详情`,
          path: 'plat/platcontract-info',
          params: {
            id: id
          }
        }
        // 动态路由
        addDynamicRoute(routeParams, this.$router)

        // }else{
        //   // 路由参数
        //   const routeParams = {
        //     routeName: `${this.$route.name}__合同信息`,
        //     title: `合同信息`,
        //     path: 'user/contractDetail',
        //     params: {
        //         isContractList:true,
        //         id: param.userId,
        //         bodyId:param.bodyId
        //     }
        //   }
        //   // 动态路由
        //   addDynamicRoute(routeParams, this.$router)
        // }

      }
    },
    childHandle(id) {
      // 路由参数
      const routeParams = {
        routeName: `${this.$route.name}__合同管理`,
        title: `合同管理`,
        path: 'plat/platcontract-add-or-update',
        params: {
          id: id
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    },
    downloadHandle(url) {

    },
    getvalue(e) {
      this.dataForm.contractType = e
      // console.log(e)
      if (e == 'grht') {
        this.headMetaIndex = 0;
        this.dataForm.expire = '';
        this.is_reader = true
        this.dataForm.settleType = 'azxjs'
      } else {
        this.getNumCount();
        this.dataForm.expire = this.headMetaIndex;
        this.is_reader = false
        this.dataForm.settleType = ''
        // this.dataForm.bodyId = this.isQyyh == 'OPERATE' ? '1453241566079012865' : ''
        this.dataForm.bodyId = ''

      }
      this.getDataList();
    },
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields()
      this.dataForm.money1 = ''
      this.dataForm.money2 = ''
      this.dataForm.startDate = ''
      this.dataForm.endDate = ''
      this.dataForm.bodyId = ''
      this.getNumCount()
      this.getDataList()
    }
  }
}
</script>
<style lang="scss" scoped>
.auxiliary-accounting-btn {
  // width: 98px;
  height: 30px;
  cursor: pointer;
  border: 0px;
  padding: 0 10px;
  background: 0;

  &.active {
    background: white;
    height: 30px;
    color: blue;
    border-bottom: 3px solid blue;
  }

  &:first-child {
    border-left: 1px solid #e6e6e6;
  }
}

.mod-plat__platcontract {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 240px);

  .el-form {
    flex-shrink: 0;
  }

  .el-table {
    flex: 1;
    margin-top: 20px;
    overflow: auto;
  }

  .el-pagination {
    flex-shrink: 0;
    margin-top: 20px;
    text-align: right;
  }
}
</style>